var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29998 8.96973L0 12.9997L4.02993 11.6997L1.29998 8.96973Z",
    fill: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55689 1.69265L2.21436 8.03516L4.97198 10.7928L11.3145 4.45027L8.55689 1.69265Z",
    fill: "#3CB4E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8057 2.01496L10.9857 0.194996C10.7257 -0.0649988 10.3357 -0.0649988 10.0757 0.194996L9.49072 0.779986L12.2207 3.50994L12.8057 2.92495C13.0657 2.66495 13.0657 2.27496 12.8057 2.01496Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/editPencil.ed0783e96f2674b1bcea7fe4a6dc8f18.svg";
export { ForwardRef as ReactComponent };